import React from "react";
import { branch } from 'baobab-react/higher-order';
import _ from "lodash";
import autoBind from "react-autobind";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import * as deepmerge from "deepmerge";
import { Button } from "react-bootstrap";
import Modal from "react-responsive-modal";

import { markdownToHtml } from "../../utils/markupUtils";
import PlayerItemValueReadOnly from "./PlayerItemValueReadOnly";
import DoneButton from "./DoneButton";
import withPlayerItemHoc from "./PlayerItemHoc";
import { getDatasourceStateTreePathForRefId, retrieveDatasourceForRef } from "../../actions/datasource";
import { showAssociatedContentCard } from "../../actions/playerActions";


const PlaceholderItem = SortableElement((item, props) => {
	const {rankingTheme} = item;
	// // console.log("Sortable Item", item, props);
	return <li className="SortableItemPlaceholder" {..._.pick(item, ["onClick"])} style={_.assign({ position: "relative", cursor: "pointer" }, rankingTheme.placeholder.panel, rankingTheme.placeholder.text)}>
		<div className="default-icon"><FontAwesomeIcon icon={rankingTheme.placeholder.icons.default} /></div>
		<div class="hover-icon"><FontAwesomeIcon icon={rankingTheme.placeholder.icons.hover} /></div>
	</li>
});

const SortableItem = SortableElement((item, props) => {
	const { label } = item.item;
	// // console.log("Sortable Item", item, props);
	return <li className="SortableItem" style={_.omit(item.style, ["display","alignItems","justifyContent"])}>
		<div style={item.textStyles} dangerouslySetInnerHTML={markdownToHtml(label)}/>	
		{item.infoComponent}
	</li>
});



const SortableList = SortableContainer(({ items }) => {
	const theme = window.activityTheme;
	let rankingTheme = _.get(theme, "item.ranking");
	return (
		<ul className="SortableList" style={rankingTheme.panel}>
			{items}
		</ul>
	);
});

class PlayerRanking extends React.Component {

	constructor(props) {
		super(props);
		this.firstLoad = true;
		this.state = {
			edit:false
		}
		autoBind(this);
	}

	showItemAssociatedContent(item, targetStyles, targetTextStyles) {
		const { listIndex, sectionIndex, itemIndex } = this.props;
		showAssociatedContentCard(item, this.props.item.associatedContentTemplate, targetStyles, targetTextStyles, listIndex, sectionIndex, itemIndex);
		// console.log("Show Associated Content");
	}

	renderInfoComponent(borderRadius, item, targetStyles, targetTextStyles) {
		return (
			<div className="associatedContent" onClick={() => { this.showItemAssociatedContent(item, targetStyles, targetTextStyles) }} style={{ borderTopLeftRadius: borderRadius, borderBottomRightRadius: borderRadius }}>
				<div/>
				{/* <Icon style={{ fontSize: 12, color: "black", position:"absolute", zIndex:3, top:5,right:5 }} name="info" /> */}
			</div>
		)
	}

	openInsertItemModal(idx, currentItems) {
		this.setState({
			insertModal: true,
			insertTarget: idx,
			currentItems
		});
	}

	doneSelectInsertItem() {
		if (this.state.insertItem && this.state.currentItems) {
			// Place new item
			const newItems = Object.assign([], this.state.currentItems);
			newItems.splice(this.state.insertTarget, 1, this.state.insertItem);
			this.onChange(newItems);
		}
		this.cancelSelectInsertItem();
	}

	cancelSelectInsertItem() {
		this.setState({
			insertModal: false,
			insertItem: null,
			insertTarget: null,
			currentItems: null
		});
	}

	renderItem({ item, index, move, moveEnd, isActive, touchable, forInsert, currentItems }) {
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		let rankingTheme = _.get(theme, "item.ranking");

		if (item.style) {
			rankingTheme = deepmerge.all([rankingTheme, item.style]);
		}

		let extraProps = {};

		if (touchable !== false) {
			if (item.placeholder) {
				extraProps = {
					onClick: () => { this.openInsertItemModal(index, currentItems) }
				}
			}
		}

		if (forInsert) {
			if (!item.placeholder) {
				extraProps.onClick = () => {
					this.setState({
						insertItem: item
					})
				};
				let targetStyles = rankingTheme.item.panelSelectableForInsert;
				let targetTextStyles = rankingTheme.item.panelSelectableForInsertText;
				if (this.state.insertItem && this.state.insertItem.value === item.value) {
					// This is it!
					targetStyles = rankingTheme.item.panelSelectableForInsertSelected;
					targetTextStyles = rankingTheme.item.panelSelectableForInsertSelectedText;
				}

				let borderRadius = targetStyles.hasOwnProperty("borderBottomRightRadius") ? targetStyles.borderBottomRightRadius : targetStyles.hasOwnProperty("borderRadius") ? targetStyles.borderRadius : 0;
				let infoComponent = null;

				if (item.associatedContent && !this.state.editModal && !this.state.insertModal) {
					infoComponent = this.renderInfoComponent(borderRadius, item, _.cloneDeep(targetStyles), targetTextStyles);
					// targetStyles.borderBottomRightRadius = 0;
				}

				return <div
							className="SortableItemReadOnly"
							style={_.assign({ position: "relative" }, targetStyles)}
							{...extraProps}>
							<div style={_.assign({}, { width: "100%", display: "flex", alignItems: "center" }, targetTextStyles)} dangerouslySetInnerHTML={markdownToHtml(item.label)} />
							{infoComponent}	
						</div>
			} else {
				return null;
			}
		} else {
			const targetStyles = _.cloneDeep(isActive ? rankingTheme.item.panelDragging : rankingTheme.item.panel);
			let borderRadius = targetStyles.hasOwnProperty("borderBottomRightRadius") ? targetStyles.borderBottomRightRadius : targetStyles.hasOwnProperty("borderRadius") ? targetStyles.borderRadius : 0;

			let infoComponent = null;

			if (item.associatedContent && !this.state.edit) {
				infoComponent = this.renderInfoComponent(borderRadius, item, _.cloneDeep(targetStyles), isActive ? rankingTheme.item.panelDraggingText : rankingTheme.item.text);
				// targetStyles.borderBottomRightRadius = 0;
			}

			let component = null;

			if (this.state.edit) {
				if (item.placeholder) {
					component = <PlaceholderItem
						style={targetStyles}
						textStyles={rankingTheme.item.text}
						item={item}
						rankingTheme={rankingTheme}
						isActive={isActive}
						index={index}
						disabled
						infoComponent={infoComponent}
						{...extraProps}>
					</PlaceholderItem>;
				} else {
					component = <SortableItem
						style={targetStyles}
						textStyles={rankingTheme.item.text}
						item={item}
						rankingTheme={rankingTheme}
						isActive={isActive}
						index={index}
						infoComponent={infoComponent}
						{...extraProps}>
					</SortableItem>;
				}
			} else {
				if (item.placeholder) {
					component = <div
						className="SortableItemPlaceholder"
						style={_.assign({ position: "relative", cursor: "pointer" }, rankingTheme.placeholder.panel, rankingTheme.placeholder.text)}
						{...extraProps}>
						<div className="default-icon"><FontAwesomeIcon icon={rankingTheme.placeholder.icons.default} /></div>
						<div class="hover-icon"><FontAwesomeIcon icon={rankingTheme.placeholder.icons.hover} /></div>
					</div>;
				} else {
					component = <div
						className="SortableItemReadOnly"
						style={_.assign({ position: "relative" }, targetStyles)}
						{...extraProps}>
						<div style={_.assign({}, { width: "100%", display: "flex", alignItems: "center" }, rankingTheme.item.text)} dangerouslySetInnerHTML={markdownToHtml(item.label)} />
						{infoComponent}
					</div>;
				}
			}

			return component;
		}
	}

	onSortEnd(items, { oldIndex, newIndex }) {
		const _items = arrayMove(items, oldIndex, newIndex);
		// console.log("Moving", items, oldIndex, newIndex, _items);
		this.onChange(_items);
	}

	onChange(items) {
		const _data = [];
		items.forEach(d => {
			if (d.placeholder) {
				_data.push(d);
			} else {
				_data.push(d.value);
			}
		})

		// console.log(_data);

		this.props.onChange(_data);
	}

	getPlaceholder() {
		return { placeholder: true };
	}

	getValues(items, config) {
		let values = [];
		const value = this.props.item.value;
		const itemsMap = _.assign({}, ...items.map(it => {
			return { [it.value]: it };
		}));
		// console.log("Get values", value, itemsMap, this.firstLoad);
		if (this.firstLoad || !value) {

			if (!_.isEmpty(value)) {
				// This has already been set

				// See if the items have changed
				// values = this.fixValues(value, items, config);

				values = value.map(val => {
					if (val.placeholder) {
						return val;
					} else {
						return itemsMap[val];
					}
				}); //For now - needs to be sorted out in case of updates to the data source

			} else {
				// No value yet
				if (config.populationBehavior === "addManually") {
					// See if this should be one by one or show all slots right away
					if (config.slotDisplay === "oneSlot") {


						values.push(this.getPlaceholder());
					} else {
						values = items.map(it => {
							return this.getPlaceholder();
						});
					}
				} else {
					// Prepopulated
					values = items;
				}
			}
			this.firstLoad = false;
		} else {

			values = value.map(val => {
				if (val.placeholder) {
					return val;
				} else {
					return itemsMap[val];
				}
			}); //For now - needs to be sorted out in case of updates to the data source
			if (config.populationBehavior === "addManually" && config.slotDisplay === "oneSlot") {

				if (values.length < items.length) {
					let hasEmptySlot = false;
					values.forEach(val => {
						if (val.placeholder) {
							hasEmptySlot = true;
						}
					});

					if (!hasEmptySlot) {
						values.push(this.getPlaceholder());
					}
				}

			}
		}
		// console.log("GET VALUES", values, itemsMap, value);
		return values;
	}

	getValuesForInsert(items, config) {
		let values = [];
		const value = this.props.item.value;
		if (!_.isEmpty(value)) {

			const valueMap = {};

			value.forEach(val => {
				if (!val.placeholder) {
					valueMap[val] = true;
				}
			})

			items.forEach(it => {
				if (!valueMap[it.value]) {
					values.push(it);
				}
			})

		} else {
			values = items;
		}

		return values;
	}

	edit() {
		this.setState({ edit: true });
	}

	doneEdit() {
		this.setState({ edit: false });
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	renderReadOnly() {
		return (
			<PlayerItemValueReadOnly item={this.props.item} />
		);
	}

	onClickDoneSubmit(values) {
		// console.log("Submitting value...", this.props.item.value);
		let targetValue = this.props.item.value;
		if (!targetValue || _.isEmpty(targetValue)) {
			if (values) {
				targetValue = [];
				values.forEach(d => {
					if (d.placeholder) {
						targetValue.push(d);
					} else {
						targetValue.push(d.value);
					}
				})
			} else {
				targetValue = [];
			}
		}
		// console.log("Final value for submit", targetValue);
		this.props.onSubmit(targetValue);
	}

	renderEditable() {

		const { item, itemsDatasourceResource, disabled, getImage, getVideo, getPdf, listIndex, sectionIndex, itemIndex } = this.props;
		const { itemsDatasource, config, items, associatedContentTemplate, x_itemsDatasource } = item;

		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const rankingTheme = _.get(theme, "item.ranking");

		// console.log(item.value + " >>> VALUE");

		let values = [];
		let valuesForInsert = [];

		// Resolve the picker items if it is tied to data source
		let loading, loadingFailure;
		if (itemsDatasourceResource && !_.isEmpty(itemsDatasourceResource)) {
			// console.log("Picker Item Data Source", itemsDatasourceResource);
			const ds = itemsDatasourceResource;
			if (ds.loading) {
				loading = <div className="SortableList" style={rankingTheme.panel}><FontAwesomeIcon
					icon='spinner'
					spin /> Loading data source...</div>;
			} else if (ds.loadingFailure) {
				loadingFailure = <div className="SortableList" style={_.assign({}, rankingTheme.panel, { color: "red" })}>Failed to load data source, picker items not available.</div>;
			} else if (ds.content) {
				const content = ds.content;
				const labelKeys = itemsDatasource.labelKeys;
				const valueKey = itemsDatasource.valueKeys[0];
				const styleKey = itemsDatasource.styleKeys[0];
				const associatedContentKey = itemsDatasource.associatedContentKeys && !_.isEmpty(itemsDatasource.associatedContentKeys) ? itemsDatasource.associatedContentKeys[0] : null;
				const hasAssociatedContentTemplate = associatedContentTemplate && !_.isEmpty(associatedContentTemplate);
				// Super hack
				if (_.indexOf(labelKeys, "employeeId") !== -1 || valueKey === "employeeId") {
					this.requiresSignaturePads = true;
				}

				const newItems = content ? content.map(entry => {

					const labelParts = labelKeys.map(labelKey => {
						return entry[labelKey];
					})

					return {
						label: labelParts.join(" "),
						value: entry[valueKey],
						searchKey: _.values(entry).join("-"),
						style: entry[styleKey],
						associatedContent: associatedContentKey && entry.hasOwnProperty(associatedContentKey) && hasAssociatedContentTemplate ? entry[associatedContentKey] : null
					}
				}) : [];

				values = this.getValues(newItems, config);
				valuesForInsert = this.getValuesForInsert(newItems, config);
			}
		} else {
			if (x_itemsDatasource && !_.isEmpty(x_itemsDatasource)) {
				// Publishing will replace the datasource and inject the items directly, in that case we still have to make sure to select the correct values
				const itemsDatasource = x_itemsDatasource;
				const labelKeys = itemsDatasource.labelKeys;
				const valueKey = itemsDatasource.valueKeys[0];
				const styleKey = itemsDatasource.styleKeys[0];
				const associatedContentKey = itemsDatasource.associatedContentKeys && !_.isEmpty(itemsDatasource.associatedContentKeys) ? itemsDatasource.associatedContentKeys[0] : null;
				const hasAssociatedContentTemplate = associatedContentTemplate && !_.isEmpty(associatedContentTemplate);
				const newItems = items.map(entry => {

					const labelParts = labelKeys.map(labelKey => {
						return entry[labelKey];
					})

					return {
						label: labelParts.join(" "),
						value: entry[valueKey],
						searchKey: _.values(entry).join("-"),
						style: entry[styleKey],
						associatedContent: associatedContentKey && entry.hasOwnProperty(associatedContentKey) && hasAssociatedContentTemplate ? entry[associatedContentKey] : null
					}
				});

				values = this.getValues(newItems, config);
				valuesForInsert = this.getValuesForInsert(newItems, config);
			} else {
				const newItems = items.map(entry => {
					let result = entry;

					if (result.hasOwnProperty("properties") && !_.isEmpty(result.properties)) {
						try {
							const obj = JSON.parse(result.properties);

							if (obj.hasOwnProperty("style")) {
								result.style = obj.style;
							}
							if (obj.hasOwnProperty("associatedContent")) {
								result.associatedContent = obj.associatedContent;
							}
						} catch (e) {
							console.warn(e);
						}
					}

					return result;
				});
				values = this.getValues(newItems, config);
				valuesForInsert = this.getValuesForInsert(newItems, config);
			}
			
		}


		// _.each(newPickerItems, (pickerItem, idx) => {
		// 	if (pickerItem.properties && pickerItem.properties !== "") {
		// 		var properties = pickerItem.properties;

		// 		var propertiesObject = JSON.parse(properties);
		// 		Object.assign(pickerItem, propertiesObject);
		// 	}
		// 	options.push({ value: pickerItem.value, label: pickerItem.label });
		// });


		let pickerComponent = <div className="SortableList">Initializing component...</div>;
		if (loading) {
			pickerComponent = loading;
		} else if (loadingFailure) {
			pickerComponent = loadingFailure;
		} else {
			// Render actual component here!!
			const _items = values.map((item, index) => {
				if (!item.placeholder) {
					return this.renderItem({ item, index, touchable: this.state.edit });//<SortableItem key={`item-${index}`} index={index} item={item} />;
				} else {
					return this.renderItem({ item, index, currentItems: values, touchable:this.state.edit });
				}
			});

			//component = <PlayerPickerButtons options={options} item={item} disabled={disabled} onChange={(value) => this.onChange(value, newPickerItems)}/>

			pickerComponent = <SortableList
				helperClass="SortableHelper" onSortStart={this.onSortStart} lockAxis="y" onSortEnd={(obj) => { this.onSortEnd(values, obj); }} items={_items} />
		}

		let doneButton;
		if (!disabled && (!item.hasOwnProperty("pickerAdvanceOnSelect") || !item.pickerAdvanceOnSelect)) {
			doneButton = <DoneButton onSubmit={()=>this.onClickDoneSubmit(values)} />;
		}

		let modal = <Modal
			open={this.state.insertModal}
			onClose={this.cancelSelectInsertItem} classNames={{ modal: "custom-modal", overlay: "ambifi-web-player" }} closeButton>
			<div>
				<h4>Choose Item To Insert</h4>
				<div className="map-modal-body-container" style={{overflowY:"auto"}}>
					{valuesForInsert.map((item, index) => {
						return this.renderItem({ item, index, touchable: this.state.edit, addSelect: true, onSelect: this.handleSelectInsertItem, forInsert: true,  currentItems: values });
					})}
				</div>
				<div className="modal-footer-container" style={{display:"flex", justifyContent:"space-between"}}>
					<Button onClick={this.cancelSelectInsertItem} style={rankingTheme.buttons.insertCancel}><FontAwesomeIcon style={rankingTheme.buttons.insertCancelText} icon="ban" /><span style={_.assign({}, rankingTheme.buttons.insertCancelText, {marginLeft:5})}>Cancel</span></Button>
					<Button onClick={this.doneSelectInsertItem} style={rankingTheme.buttons.insertDone}><FontAwesomeIcon style={rankingTheme.buttons.insertDoneText} icon="check" /><span style={_.assign({}, rankingTheme.buttons.insertDoneText, { marginLeft: 5 })}>Done</span></Button>
				</div>
			</div>
		</Modal>;

		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const component = <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
			<div style={{ width: "100%", overflow: "visible" }}>
				<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
				<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
				{getImage()}
				{getVideo()}
				{getPdf()}
				<div style={{ marginBottom: "16px" }}>
					{pickerComponent}
				</div>
				{!this.state.edit && <div style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "space-between" }}>
					{doneButton}

					<Button onClick={this.edit} style={rankingTheme.buttons.editFullscreen}><FontAwesomeIcon style={rankingTheme.buttons.editFullscreenText} icon="pen-square" /><span style={_.assign({}, rankingTheme.buttons.editFullscreenText, { marginLeft: 5 })}>Edit</span></Button>
				</div>}
				{this.state.edit && <div style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "flex-start" }}>
					<Button onClick={this.doneEdit} style={rankingTheme.buttons.editFullscreen}><FontAwesomeIcon style={rankingTheme.buttons.editFullscreenText} icon="check-square" /><span style={_.assign({}, rankingTheme.buttons.editFullscreenText, { marginLeft: 5 })}>Done</span></Button>
				</div>}
			</div>
			{modal}
		</div>;
		return component;
	}

	componentDidMount() {
		const { item } = this.props;
		// console.log("Did mount", item);
		if (item && item.itemsDatasource && !_.isEmpty(item.itemsDatasource)) {
			// console.log("Going to retrieve and inject datasource");
			retrieveDatasourceForRef(item.itemsDatasource);
		}
	}
}
export default branch((props) => {
	const branches = {}
	// self.props.listIndex, self.props.sectionIndex, self.props.itemIndex
	if (props.item && props.item.itemsDatasource && !_.isEmpty(props.item.itemsDatasource) && props.hasOwnProperty("listIndex") && props.hasOwnProperty("sectionIndex") && props.hasOwnProperty("itemIndex")) {
		// tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
		const path = getDatasourceStateTreePathForRefId(props.item.itemsDatasource.refId);
		// console.log("Hooking up data source for branch", props.item.itemsDatasource, path);
		if (path) {
			branches.itemsDatasourceResource = path;
		}
	}

	return branches;
}, withPlayerItemHoc(PlayerRanking));